import request from '@/utils/request';
const baseURLAdmin = process.env.VUE_APP_ADMIN;

const baseUserURL = process.env.VUE_APP_USER; // /user

/**
 * 大件订单看板————获取订单总览统计
 */
export const getCargoOrderSummary = (data) => {
  return request({
    url: `/report/cargo/getCargoOrderSummary`,
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};

/**
 * 大件订单看板————获取运单状态统计
 */
export const getCargoWaybillMonitor = (data) => {
  return request({
    url: `/report/cargo/getCargoWaybillMonitor`,
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};

/**
 * 大件订单看板————获取在途运单按州统计
 */
export const getCargoTransitMonitor = (data) => {
  return request({
    url: `/report/cargo/getCargoTransitMonitor`,
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};

/**
 * 大件称重记录————全部导出
 */
export const weightRecordAllExport = (data) => {
  return request({
    url: `/cargoOrder/weightRecordAllExport`,
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};

/**
 * 大件称重记录————勾选导出
 */
export const weightRecordExport = (data) => {
  return request({
    url: `/cargoOrder/weightRecordExport`,
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};

/**
 * 大件称重记录————分页
 */
export const weightRecordPage = (data) => {
  return request({
    url: `/cargoOrder/weightRecord`,
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};

/**
 * 揽收装车记录————所有车辆下拉，默认展示10条
 */
export const queryVehiclePage = (data) => {
  return request({
    url: `/collectVehicle/queryVehiclePage?pageSize=10&vehicleNumber=${data}`,
    method: 'get',
    baseURL: baseURLAdmin
  });
};
/**
 * 揽收装车记录————查询所属网点州
 */
export const queryState = (data) => {
  return request({
    url: `/site/queryOptionSelectForState?name=${data}&pageSize=1000`,
    method: 'get',
    baseURL: baseURLAdmin
  });
};
/**
 * 揽收装车记录————所有网点下拉，默认展示10条
 */
export const query10Site = (data) => {
  return request({
    url: `/site/queryPage?name=${data}`,
    method: 'get',
    baseURL: baseURLAdmin
  });
};
/**
 * 揽收装车记录————所有员工下拉，默认展示10条
 */
export const query10User = (data) => {
  return request({
    url: `/queryPage?realName=${data}`,
    method: 'get',
    baseURL: baseUserURL
  });
};
/**
 * 揽收装车记录————所有客户下拉，默认展示10条
 */
export const queryCustomerName = (data) => {
  return request({
    url: `/customer/queryPage?customerName=${data}`,
    method: 'GET',
    baseURL: baseURLAdmin
  });
};

/**
 * 揽收装车记录————分页
 */
export const collectBulkyLoadPage = (data) => {
  return request({
    url: `/collectBulkyLoad/page`,
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};

/**
 * 揽收装车记录————导出
 */
export const collectBulkyLoadExportAll = (data) => {
  return request({
    url: `/collectBulkyLoad/exportAll`,
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// 大件下单协议记录
export const agreementRecordPage = (data) => {
  return request({
    url: `/agreementRecord/page`,
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// 导出
export const agreementRecordExport = (data) => {
  return request({
    url: `/agreementRecord/export`,
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
